<template>
    <div class="sign-in">
		<a-row type="flex" :gutter="[24,24]" justify="space-around" align="middle" class="row-main">
			<div class="img">
				<a-result status="404" title="404" sub-title="Sorry, the page you visited does not exist.">
                    <template #extra>
                        <a-button type="primary">
                                Back Home
                        </a-button>
                    </template>
                </a-result>
			</div>
		</a-row>
	</div>
</template>

<script>

export default {
	inject : ['eventBus'],

	data () {
		return {


		}
	},
	methods : {
		

	},
	
}
</script>
